// FILE: client/src/pages/secure/NoAgencyDisclosurePage.js
// (This is a NEW file)

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApiClient } from '../../hooks/useApiClient';

const NoAgencyDisclosurePage = () => {
    const [clients, setClients] = useState([]);
    const [formData, setFormData] = useState({
        client_id: '',
        property_address: '',
        disclosure_date: new Date().toISOString().split('T')[0],
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [generatedFile, setGeneratedFile] = useState(null);
    const apiClient = useApiClient();

    useEffect(() => {
        // Fetch clients to populate the consumer dropdown
        apiClient.get('/api/clients').then(response => {
            if (Array.isArray(response)) {
                setClients(response);
            } else {
                setClients([]);
            }
        }).catch(err => {
            console.error("Failed to fetch clients", err);
            setClients([]);
        });
    }, [apiClient]);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setGeneratedFile(null);
        try {
            const response = await apiClient.post('/api/forms/generate-no-agency', formData, { responseType: 'blob' });
            
            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            setGeneratedFile(fileURL);

        } catch (error) {
            console.error("Failed to generate disclosure", error);
            alert(error.response?.data?.message || 'An error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="p-4 md:p-8">
            <Link to="/dashboard/forms" className="text-indigo-600 hover:underline mb-6 inline-block">&larr; Back to Forms Portal</Link>
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
                <h1 className="text-2xl font-bold text-slate-800 mb-2">Disclosure of No Agency Relationship</h1>
                <p className="text-slate-500 mb-6">Fill out the details to generate the disclosure form.</p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="client_id" className="block text-sm font-medium text-gray-700">Select Consumer</label>
                        <select id="client_id" name="client_id" value={formData.client_id} onChange={handleChange} required className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm">
                            <option value="">-- Choose a consumer --</option>
                            {clients.map(client => (
                                <option key={client.client_id} value={client.client_id}>{client.first_name} {client.last_name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="property_address" className="block text-sm font-medium text-gray-700">Property Address (if applicable)</label>
                        <input type="text" id="property_address" name="property_address" value={formData.property_address} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label htmlFor="disclosure_date" className="block text-sm font-medium text-gray-700">Date of Disclosure</label>
                        <input type="date" id="disclosure_date" name="disclosure_date" value={formData.disclosure_date} onChange={handleChange} required className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm" />
                    </div>
                    
                    <div className="flex justify-end">
                        <button type="submit" disabled={isSubmitting} className="px-6 py-2 bg-slate-800 text-white rounded-md disabled:bg-indigo-400">
                            {isSubmitting ? 'Generating...' : 'Generate Disclosure PDF'}
                        </button>
                    </div>
                </form>

                {generatedFile && (
                    <div className="mt-8 border-t pt-6">
                        <h3 className="text-lg font-bold">Disclosure Generated Successfully</h3>
                        <a href={generatedFile} download={`NoAgencyDisclosure_${formData.client_id}.pdf`} className="inline-block px-6 py-2 bg-green-600 text-white rounded-md">
                            Download PDF
                        </a>
                        <div className="mt-4 h-96">
                           <iframe src={generatedFile} width="100%" height="100%" title="Generated Disclosure Preview"></iframe>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NoAgencyDisclosurePage;
